import React from 'react';
import AppHeader from './AppHeader';
import { useHeaderContext } from '@/contexts/HeaderContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { title, onBack } = useHeaderContext();
  return (
    <div className="min-h-screen bg-background">
      <AppHeader title={title} onBack={onBack} />
      {children}
    </div>
  );
};

export default Layout;
